import { DashboardLayout } from "components/layout/components/DashboardLayout";
import { useGlobalContext } from "stateManagers/GlobalContext";
import { Navbar } from "components/layout/components/Navbar";
import { TalentsTable } from "../components/TalentsTable";
import { useEffect, useRef, useState } from "react";
import { FilterModal } from "../components/FilterModal";
import { ITalent } from "../types";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import * as XLSX from "xlsx";

export const Talents = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const talentsTableRef = useRef<{ getFilteredData: () => ITalent[] }>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { token } = useGetUserInfo();
  const { setFilterTalent } = useGlobalContext(); 


  const handleSearch = (value: string) => {
    setSearchTerm(value);
  };

  useEffect(() => {
    setFilterTalent({
      sector: null,
      experience: null,
      gender: null,
      location: null,
      skills: null,
      jobTitle: null,
      visibilityScore: null,
      assessmentStatus: null,
      relocate: null,
    });
  }, [setFilterTalent]);

  const handleDownloadXLSX = async () => {
    try {
      const response = await fetch(
        `${END_POINT.BASE_URL}/v1/get-download-talents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const result = await response.json();
      const allData: ITalent[] = result.data || [];


      const worksheetData = allData.map((talent) => {
        const currentJob = getCurrentJob(talent.work_histories);
        const experienceLevel = formatExperienceLevel(talent.experience_level || "");
        const middleName = talent.middle_name ?? "";

        return {
          "Talent Name": `${talent.first_name} ${middleName} ${talent.last_name}`,
          "Present Job Role": currentJob?.title || "",
          "Present Employer": currentJob?.company || "",
          "Experience Level": experienceLevel,
          "Visibility Score": talent.visibility_score,
          Status: "Active",
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Talents");

      XLSX.writeFile(workbook, `talents-${new Date().getTime()}.xlsx`);
    } catch (error) {
      console.error("Error downloading XLSX:", error);
    }
  };

  const getCurrentJob = (workHistories: any[]) => {
    return workHistories?.find((job) => job.is_current === 1);
  };

  const formatExperienceLevel = (level: string): string => {
    return level
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <DashboardLayout>
      <Navbar title="Talents" description="View and manage Talents" />
      <FilterModal open={openFilter} handleClose={() => setOpenFilter(false)} />
      <div className="bg-gray-100 px-4 py-3 mt-8 rounded-md">
        <div className="flex gap-3 flex-col md:flex-row md:justify-between md:items-center">
          {/* <button
          className="transparentButton flex items-center gap-x-2"
          data-tour="download-csv"
          style={{ background: "white" }}
          onClick={handleDownloadXLSX}
        >
          <i className="ri-download-cloud-2-line text-base"></i>
          <span>Download XLSX</span>
        </button> */}
          <div className="flex items-center">
            <div className="relative w-full">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none ">
                <i className="ri-search-line text-xl text-gray-500"></i>
              </div>
              <input
                type="search"
                id="job-search-input"
                className="border focus:outline-none border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5 pr-24"
                placeholder="Search Talents"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>
          <button
            className="transparentButton flex items-center gap-x-2"
            style={{ background: "white" }}
            data-tour="talent-filters"
            onClick={() => setOpenFilter(true)}
          >
            <i className="ri-filter-3-line text-base"></i>
            <span>Filters</span>
          </button>
        </div>
      </div>

      <TalentsTable data-tour="talent-table" searchTerm={searchTerm} ref={talentsTableRef} />
    </DashboardLayout>
  );
};
